import React from 'react';
import { useParams } from 'react-router-dom';
import SEODirectoryPage from './SEODirectoryPage';
import DirectoryProfilePage from './DirectoryProfilePage';

/**
 * Smart router: if the param matches a known industry/company-type slug,
 * render the SEO directory page. Otherwise, treat it as a profile ID.
 */

const KNOWN_SLUGS = new Set([
  // Industries
  'manufacturing', 'import-export', 'wholesale', 'retail', 'technology',
  'services', 'construction', 'automotive', 'food-beverage', 'healthcare',
  'electronics', 'textiles', 'chemicals', 'packaging',
  // Company types
  'manufacturers', 'distributors', 'wholesalers', 'service-providers', 'trading-companies'
]);

export default function DirectoryRouter() {
  const { slug } = useParams();

  if (KNOWN_SLUGS.has(slug)) {
    return <SEODirectoryPage />;
  }

  // Not a known category — treat as profile ID
  return <DirectoryProfilePage />;
}
